import { useState, useCallback } from "react";
const createStoredStateHook = (getStorage) => {
  return (key, initializeValue) => {
    const storage = getStorage();
    const [value, setValue] = useState(() => {
      const value2 = storage.getItem(key);
      const parsedValue = value2 !== null ? JSON.parse(value2) : void 0;
      return initializeValue(parsedValue);
    });
    return [value, useCallback((value2) => {
      setValue((current) => {
        const newValue = typeof value2 === "function" ? value2(current) : value2;
        storage.setItem(key, JSON.stringify(newValue));
        return newValue;
      });
    }, [key, storage])];
  };
};
const useSessionStorageState = createStoredStateHook(() => sessionStorage);
export {
  useSessionStorageState
};
//# sourceMappingURL=useStoredState.js.map
